<template>
  <div id="contenedor-eliminar-subtipo-obra">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar subtipo de obra </v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¿Desea eliminar el subtipo de obra "{{subTipoObraEliminar.descripcion}}"?
        </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarSubTipoObra"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixCatalogoSubTiposObra from './mixCatalogoSubTiposObra';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogosSubtiposdeobraEliminar',
  mixins: [mixCatalogoSubTiposObra],
  props: {
    subTipoObraEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
